export interface Container {
  id: string
  name: string
  image: string
  labels: { [name: string]: string } | null
}

export interface InfraClientsResponse {
  active: Client[]
  inactive: Client[]
  idle: Client[]
}

export enum ClientAuthType {
  SECRET = 'SECRET',
  CERTIFICATE = 'CERTIFICATE'
}

export enum ClientState {
  Active = 'ACTIVE',
  Idle = 'IDLE',
  Revoked = 'REVOKED',
  Invited = 'INVITED',
  Inactive = 'INACTIVE'
}

export enum ClientStatus {
  HEALTHY = 'HEALTHY',
  IMPAIRED = 'IMPAIRED',
  UNHEALTHY = 'UNHEALTHY'
}

export interface ValidationAttackResult {
  attack_type: string
  status: 'SUCCESS' | 'ERROR'
  targeting: 'HOST' | 'CONTAINER'
  raw_errors: string[]
}

export interface ValidationResults {
  timestamp: number
  client_version: string
  client_status: ClientStatus
  results: ValidationAttackResult[]
}

export interface NetworkInterfaceIPAddress {
  ip: string
  protocol_family: 'INET' | 'INET6'
}

export interface NetworkInterface {
  name: string
  ip_addresses: NetworkInterfaceIPAddress[]
  is_default: boolean
  is_physical: boolean
  is_virtual: boolean
}

export interface NetworkInterfaceData {
  interfaces?: NetworkInterface[]
}

export interface ClientWarning {
  key: string
  link: string
  summary: string
}

export interface Client {
  active?: boolean
  attributes?: { [key: string]: any }
  auth_type?: ClientAuthType
  container_hash?: number
  container_driver?: string
  container_runtime?: string
  container_runtime_api_version?: string
  container_runtime_version?: string
  containers: Container[]
  created_at?: Date
  dns_servers?: string[]
  docker_version?: string
  gremlin_client_version?: string
  id?: string
  identifier: string
  idle?: boolean
  instance_start_time?: string
  kubernetes_version?: string
  labels?: Record<string, string>
  last_active_emitted?: Date
  last_seen?: Date
  metrics_enabled?: boolean
  network_interface_data?: NetworkInterfaceData
  network_interface_data_hash?: number
  org_id?: string
  os_name?: string
  os_type?: string
  os_version?: string
  process_collection_enabled?: boolean
  proxied?: boolean
  revoked?: boolean
  revoked_by?: string
  service?: string
  service_or_default?: string
  state?: ClientState
  tags?: Record<string, string>
  updated_at?: Date
  warnings: ClientWarning[]
  validation_results?: ValidationResults
  version_info: { gremlind: string; gremlin: string }
}
